var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconapuntualita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.888,
    height: 123.888,
    viewBox: "0 0 123.888 123.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_6",
    "data-name": "Rettangolo 6",
    width: 123.888,
    height: 123.888,
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M114.033,14.078l-6.8,5.631A61.246,61.246,0,0,0,61.944,0a61.944,61.944,0,1,0,61.944,61.944,59,59,0,0,0-3.752-21.117,4.011,4.011,0,0,0-7.511,2.816,55.062,55.062,0,0,1,3.285,18.536A53.966,53.966,0,1,1,61.944,8.212a53.389,53.389,0,0,1,39.184,16.894L61.944,56.782,49.978,45.754a3.935,3.935,0,0,0-5.162-.235,4.284,4.284,0,0,0-.939,5.162l14.547,24.4a4.671,4.671,0,0,0,2.816,1.877h.469a3.886,3.886,0,0,0,2.816-1.173l54.9-55.843a3.976,3.976,0,0,0,0-5.4,3.771,3.771,0,0,0-5.4-.469",
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M32.578,11.7V9.589a3.989,3.989,0,1,0-7.978,0V11.7a4.112,4.112,0,0,0,3.989,3.989A3.955,3.955,0,0,0,32.578,11.7",
    transform: "translate(33.121 7.54)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M28.589,42.9A4.111,4.111,0,0,0,24.6,46.886V49a3.989,3.989,0,1,0,7.978,0V46.654A3.765,3.765,0,0,0,28.589,42.9",
    transform: "translate(33.121 57.759)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M46.789,24.7a3.989,3.989,0,1,0,0,7.978H48.9a3.989,3.989,0,1,0,0-7.978Z",
    transform: "translate(57.624 33.255)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M9.589,24.7a3.989,3.989,0,1,0,0,7.978H11.7a3.989,3.989,0,1,0,0-7.978Z",
    transform: "translate(7.54 33.255)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconapuntualita);
export default __webpack_public_path__ + "static/media/iconapuntualita.088415e53cff7de6313423d21e83d720.svg";
export { ForwardRef as ReactComponent };